<template>
  <section>

    <div class="quiz-result__entered-answer container-sm" v-if="pageType === 'text_entry' || pageType === 'essay_type'">
      <div class="quiz-result__entered-answer-title">{{ $t('common.modal.preview.entered_answer') }}</div>
      <div class="quiz-result__entered-answer-value">
        {{ submittedValue }}
      </div>
    </div>

    <div class="quiz-result">
      <div class="container-sm">
        <div class="quiz-result__content row" v-if="pageType !== 'essay_type'">

          <div class="col-6">
            <img
              v-if="quizResult.is_correct"
              src="@/assets/images/quiz-correct-s.svg"
              class="quiz-correct-s inline-block"
            >
            <img
              v-else
              src="@/assets/images/quiz-wrong-s.svg"
              class="quiz-wrong-s inline-block"
            >
            <strong class="quiz-result__label" v-if="quizResult.is_correct">
              {{ $t('viewer.page.quiz.result.correct') }}
            </strong>
            <strong class="quiz-result__label" v-else>
              {{ $t('viewer.page.quiz.result.wrong') }}
            </strong>
          </div>

          <div class="col-6 quiz-result__description" v-if="pageType === 'multiple_choice' && selectedOptionIndex">
            <span class="quiz-result__selected" :class="quizResultSelected(quizResult.is_correct)">
              <span>
                {{ $t('common.modal.preview.chosen_answer') }}
                {{ $t('common.modal.preview.answer_number', { n: selectedOptionIndex }) }}
              </span>
            </span>

            <span class="quiz-result__answer">
              {{ $t('common.modal.preview.correct_answer') }}
              <span>
                {{ $t('common.modal.preview.answer_number', { n: correctOptionIndex }) }}
              </span>
            </span>

          </div>
        </div>

        <div class="quiz-result__content" v-else>
          <div class="row quiz-result-score">

            <div class="col-12 col-sm-6">
              <strong class="quiz-result__label typography-font-weight-600" v-if="!quizResult.is_graded">
                {{ $t('viewer.quiz.result.score_labels.not_graded') }}
              </strong>

              <template v-else>
                <strong class="quiz-result__essay-type-label typography-font-weight-600">
                  {{ $t('viewer.page.completed.graded') }}
                </strong>
                <span class="quiz-result__value">
                  <strong>{{ quizResult.score }}</strong>/{{ $t('common.numeric_score', { n: quiz.score }) }}
                </span>
              </template>
            </div>

          </div>
        </div>

      </div>
    </div>

    <div class="quiz-result__answer-content container-sm" v-if="pageType === 'text_entry' && !quizResult.is_correct">
      <div class="quiz-result__answer-content-title">{{ $t('viewer.card.assignment.correct.answer') }}</div>
      <div class="quiz-result__answer-content-value">
        {{ correctAnswerContents }}
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'quiz-result',

  props: [
    'quiz',
    'pageType',
  ],

  computed: {
    ...mapGetters({
      correctOptionIndex: 'getCorrectOptionIndex',
      correctAnswerContents: 'getCorrectAnswerContents',
      selectedOptionIndex: 'getSelectedOptionIndex',
      quizAnswerValue: 'getQuizAnswerValue',
      quizResult: 'getQuizResult',
    }),

    scoreRatio() {
      if (this.quizResult) {
        return this.quizResult.score / this.quiz.score;
      }

      return 0;
    },

    submittedValue() {
      if (this.quizResult && this.quizResult.value) {
        return this.quizResult.value.replace(/\n/g, '<br>');
      }

      return '';
    },

  },

  methods: {
    quizResultSelected(isCorrect) {
      return isCorrect ? '' : 'active';
    },
  },

};
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/components/_typographies';
  @import '@/assets/styles/components/_breakpoints';

  .quiz-result {
    background-color: rgba(0,0,0,.02);
  }

  .quiz-result__content {
    max-width: 570px;
    margin: 0 auto;

    padding: 20px 0;
    position: relative;

    .quiz-correct-s,
    .quiz-wrong-s {
      width: 24px;
    }
  }

  .quiz-result-score {
    .col-12 {
      line-height: 60px;
    }

    img {
      width: initial !important;
    }
  }

  .quiz-result__label {
    font-size: 17px;
    font-weight: 400;

    @media (min-width: $desktop-breakpoint) {
      font-size: 20px;
    }
  }

  .quiz-result__essay-type-label {
    font-weight: 400;
    font-size: 17px;
    color: #ffc107;

    @media (min-width: $desktop-breakpoint) {
      font-size: 20px;
    }
  }

  .quiz-result__value {
    padding: 0px 12px 0px 12px;
    font-size: 17px;
    line-height: 1.65;
    font-weight: normal;

    line-height: 1.43;

    @media (min-width: $desktop-breakpoint) {
      font-size: 18px;
      line-height: 1.6;
    }

  }

  .quiz-result__description {
    line-height: 2;
    margin: 0;
    text-align: right;
    font-size: 14px;
    line-height: 1.43;

    @media (min-width: $desktop-breakpoint) {
      font-size: 18px;
    }

    >.quiz-result__selected {
      display: 'inline-block';
      padding-left: 12px;
    }

    .active{
      color: #ff595f;
    }

    >.quiz-result__answer {
      display: inline-block;
      padding-left: 12px;
      color: #03a9f4;
    }

  }

  .quiz-result__entered-answer {
    padding: 16px;

    .quiz-result__entered-answer-title {
      font-size: 14px;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.54);
      padding: 6px 0px 6px 0px;
    }

    .quiz-result__entered-answer-value {
      background-color: #f5f5f5;
      border: solid 1px #eeeeee;
      border-radius: 4px;
      padding: 14px;
      font-size: 14px;
    }
  }

  .quiz-result__answer-content {
    padding: 14px;

    .quiz-result__answer-content-title {
      font-size: 14px;
      font-weight: bold;
      color: #03a9f4;
      padding: 6px 0px 6px 0px;
    }
  }

</style>
